import get from 'lodash/get';

const sessionStore = new class MagicStore {
	constructor() {
		try {
			this._data = JSON.parse(window.sessionStorage.getItem('sessionStore')) || {};
		} catch (e) {
			this._data = {};
		}
		this.$data = new Proxy(this._data, {
			get(target, prop) {
				return target[prop] || null;
			},
			set(target, prop, value) {
				target[prop] = value;
				window.sessionStorage.setItem('sessionStore', JSON.stringify(target));
				return true;
			}
		});
	}

	get(target, prop) {
		return get(this.$data, prop, '⚠ ' + prop);
	}
};

export default sessionStore;
